/**
 * Image element that can never render broken.
 *
 * `src` (database / Media Library URL) has priority; if it is empty or fails
 * to load, the bundled demo `fallback` is shown instead.
 */
import { useEffect, useState } from "react";

type Props = Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src"> & {
  src?: string | null;
  fallback: string;
};

export function SafeImage({ src, fallback, alt = "", ...rest }: Props) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  const resolved = !src || failed ? fallback : src;
  return (
    <img
      {...rest}
      src={resolved}
      alt={alt}
      onError={() => {
        if (!failed) setFailed(true);
      }}
    />
  );
}